export default __webpack_public_path__ + "static/media/AcIconOn.74330241.svg";